export default __webpack_public_path__ + "static/media/chevron-right.4516b4a9.svg";